// extracted by mini-css-extract-plugin
export default {"imagesContainer":"PhoneScreenshots_imagesContainer__eo+K1","image":"PhoneScreenshots_image__xCEHl"};